import type { FC, SVGProps } from "react";
import DoctorsAndSpecialistsSvg from "src/ui/components/CareTeamSection/doctors_and_specialists.svg?react";
import HealthCoachSvg from "src/ui/components/CareTeamSection/health_coach.svg?react";
import PatientCareAdvocatesSvg from "src/ui/components/CareTeamSection/patient_care_advocates.svg?react";
import PharmacistSvg from "src/ui/components/CareTeamSection/pharmacist.svg?react";
import RegisteredDietitiansSvg from "src/ui/components/CareTeamSection/registered_diet.svg?react";
import RegisteredNursesSvg from "src/ui/components/CareTeamSection/registered_nurses.svg?react";
import VirtualAssistantSvg from "src/ui/components/CareTeamSection/virtual_assistant.svg?react";

/**
 * Care Team card background variants — one per role. Each variant maps to
 * a distinct SVG artwork provided by design (see the sibling `*.svg` files).
 *
 * The names mirror the role `id`s in `careTeamRoles.ts` so the variant is
 * effectively the role identifier the card uses to look up its background.
 */
export type CareTeamCardVariant =
  | "healthCoaches"
  | "registeredDietitians"
  | "registeredNurses"
  | "pharmacist"
  | "doctorsAndSpecialists"
  | "patientCareAdvocates"
  | "sophie";

const VARIANT_SVG: Record<CareTeamCardVariant, FC<SVGProps<SVGSVGElement>>> = {
  healthCoaches: HealthCoachSvg,
  registeredDietitians: RegisteredDietitiansSvg,
  registeredNurses: RegisteredNursesSvg,
  pharmacist: PharmacistSvg,
  doctorsAndSpecialists: DoctorsAndSpecialistsSvg,
  patientCareAdvocates: PatientCareAdvocatesSvg,
  sophie: VirtualAssistantSvg
};

interface Props {
  variant: CareTeamCardVariant;
}

const CardBackground: FC<Props> = ({ variant }) => {
  const Svg = VARIANT_SVG[variant];
  return (
    <Svg
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden
    />
  );
};

export default CardBackground;
